export default __webpack_public_path__ + "static/media/Five.ec392f24.jpeg";